import styles from "./NotFound.module.css";

function NotFound() {
  return (
    <div className={styles.container_total}>
      <div className={styles.container_card_erro}>
        <h1 className={styles.erro_codigo}>404</h1>
        <h2 className={styles.titulo}>Página Não Encontrada</h2>
        <p className={styles.mensagem}>
          A página que você está procurando não existe ou foi movida.
        </p>
        <a href="/" className={styles.botao_home}>
          Voltar para Home
        </a>
      </div>
    </div>
  );
}

export default NotFound;
